import styled from 'styled-components';

export const ItemPrice = styled.span`
  font-size: 1.1rem;
  color: ${Styles.color.black};
  white-space: nowrap;
`;
